module.exports = __webpack_public_path__ + "media/images/how-we-test__chief-scientist-2df16524da9d8289fc0167775e598c73.jpg";